const riot = require('riot');

riot.tag2('popup-note-list', '<div class="w342 max-width-90vw p8" ref="popup"> <div class="f fm flex-between px8 mb4"> <div class="bold fs13">{opts.title}</div> <div class="p4 cursor-pointer" onclick="{close}"><i class="icon-close fs20 text-label_dark_medium"></i></div> </div> <div class="overflow-y-scroll scrollbar-none max-height-70vh p8" if="{opts.notes.length}"> <div class="relative mb16 mb0-last" each="{note, index in opts.notes}"> <div class="hover-board-shadow box-shadow-primary rounded-8 overflow-hidden transition" data-is="item-note" item="{note}" onclick="{onSelect}"></div> <button class="absolute tn4 rn4 hover-trigger" onclick="{onRemove}"> <div class="s24 circle bg-white f fh hover-bg-pale transition"><span class="icon-close cursor-pointer p8 fs18"></span></div> </button> </div> </div> <div class="f fh p16" if="{!opts.notes.length}"> <div class="text-label_dark_medium fs12 lh18 white-space-pre-wrap">{opts.emptyText}</div> </div> </div>', 'popup-note-list,[data-is="popup-note-list"]{display:block}', 'class="bg-white box-shadow-primary rounded-8"', function(opts) {

    this.onSelect = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const note = e.item.note;
      if (note) {
        this.trigger('select', note);
      }
    };

    this.onRemove = (e) => {
      const note = e.item.note;
      if (note) {
        this.trigger('remove', note.path);
      }
    };
});